/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the sale price by (1 − discount % ÷ 100). If an item costs $76 after a 20% discount, divide 76 by 0.80 to get the original price of $95. This reverses the discount formula, which is useful when a receipt only shows the final price and the percentage off.`)
};

const es_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide el precio de venta entre (1 − % de descuento ÷ 100). Si un artículo cuesta $76 después de un 20% de descuento, divide 76 entre 0,80 para obtener el precio original de $95. Esto invierte la fórmula del descuento, lo cual es útil cuando un recibo solo muestra el precio final y el porcentaje de descuento.`)
};

const de_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile den Verkaufspreis durch (1 − Rabatt % ÷ 100). Kostet ein Artikel nach 20% Rabatt $76, teile 76 durch 0.80, um den ursprünglichen Preis von $95 zu erhalten. Das kehrt die Rabattformel um, was nützlich ist, wenn ein Beleg nur den Endpreis und den Rabattsatz zeigt.`)
};

const nl_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel de verkoopprijs door (1 − korting % ÷ 100). Als een artikel na 20% korting $76 kost, deel je 76 door 0.80 om de oorspronkelijke prijs van $95 te krijgen. Dit keert de kortingsformule om, wat nuttig is wanneer een bon alleen de eindprijs en het kortingspercentage toont.`)
};

const fr_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez le prix soldé par (1 − réduction % ÷ 100). Si un article coûte 76 $ après une réduction de 20 %, divisez 76 par 0,80 pour obtenir le prix d’origine de 95 $. Cela inverse la formule de réduction, ce qui est utile quand un reçu n’indique que le prix final et le pourcentage de réduction.`)
};

const it_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi il prezzo scontato per (1 − % sconto ÷ 100). Se un articolo costa $76 dopo uno sconto del 20%, dividi 76 per 0.80 per ottenere il prezzo originale di $95. Questo inverte la formula dello sconto, utile quando uno scontrino mostra solo il prezzo finale e la percentuale di sconto.`)
};

const pt_br2_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o preço de venda por (1 − desconto % ÷ 100). Se um item custa $76 depois de um desconto de 20%, divida 76 por 0.80 para obter o preço original de $95. Isso reverte a fórmula do desconto, o que é útil quando um recibo mostra apenas o preço final e a porcentagem de desconto.`)
};

const pt_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o preço de venda por (1 − % de desconto ÷ 100). Se um artigo custa $76 depois de um desconto de 20%, divida 76 por 0.80 para obter o preço original de $95. Isto inverte a fórmula do desconto, o que é útil quando um recibo só mostra o preço final e a percentagem de desconto.`)
};

const ja_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セール価格を(1 − 割引% ÷ 100)で割ります。商品が20%割引後に76ドルの場合、76を0.80で割ると元の価格95ドルが求まります。これは割引の式を逆算するもので、領収書に最終価格と割引率しか記載されていない場合に役立ちます。`)
};

const zh_pct_discount_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用促销价除以 (1 − discount % ÷ 100)。如果商品在 20% 折扣后售价 $76，用 76 除以 0.80 得到原价 $95。这是对折扣公式做逆运算，当收据只显示最终价格和折扣百分比时非常有用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq4_a", locale)
	if (locale === "en") return en_pct_discount_faq4_a(inputs)
	if (locale === "es") return es_pct_discount_faq4_a(inputs)
	if (locale === "de") return de_pct_discount_faq4_a(inputs)
	if (locale === "nl") return nl_pct_discount_faq4_a(inputs)
	if (locale === "fr") return fr_pct_discount_faq4_a(inputs)
	if (locale === "it") return it_pct_discount_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq4_a(inputs)
	if (locale === "pt") return pt_pct_discount_faq4_a(inputs)
	if (locale === "ja") return ja_pct_discount_faq4_a(inputs)
	return zh_pct_discount_faq4_a(inputs)
};